var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 70 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2505 52.5165H37.0099L33.8299 40.3847C33.679 39.8267 33.3585 39.3333 32.8871 39.1008C31.7106 38.5165 30.4142 38.0514 29 37.8169V37.3498H35.8313C36.7742 37.3498 37.4813 38.0514 37.5991 38.8663L39.2491 47.6173L43.4877 37.3498H47.6104L41.2505 52.5165ZM49.9675 52.5165H45.9626L49.2604 37.3498H53.2653L49.9675 52.5165ZM58.4467 41.5514C58.5646 40.7346 59.2717 40.2675 60.0967 40.2675C61.3931 40.1502 62.8052 40.3848 63.9838 40.9671L64.6909 37.7016C63.5123 37.2345 62.216 37 61.0395 37C57.1524 37 54.3239 39.1008 54.3239 42.0165C54.3239 44.2346 56.3274 45.3992 57.7417 46.1008C59.2717 46.8004 59.861 47.2675 59.7431 47.9671C59.7431 49.0165 58.5646 49.4836 57.3881 49.4836C55.9739 49.4836 54.5596 49.1338 53.2653 48.5494L52.5582 51.8169C53.9724 52.3992 55.5025 52.6338 56.9167 52.6338C61.2752 52.749 63.9838 50.6502 63.9838 47.5C63.9838 43.5329 58.4467 43.3004 58.4467 41.5514ZM78 52.5165L74.82 37.3498H71.4044C70.6972 37.3498 69.9901 37.8169 69.7544 38.5165L63.8659 52.5165H67.9887L68.8116 50.3004H73.8772L74.3486 52.5165H78ZM71.9936 41.4342L73.1701 47.1502H69.8723L71.9936 41.4342Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9f1767c83dcb64cfba39cb6ee30640da.svg";
export { ForwardRef as ReactComponent };